import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {AnalyticsService} from '../../services/analytics/analytics.service';
import {EventEnum, PathUrlEnum} from '../../../utils/analytics.utils';
import {RouteUtils} from "../../../utils/route.utils";

@Component({
  selector: 'app-error-screen',
  templateUrl: './error-screen.component.html',
  styleUrls: ['./error-screen.component.scss'],
})
export class ErrorScreenComponent implements OnInit {
  @Output() onClickTryAgain = new EventEmitter<boolean>();
  @Input() errorCount: number = 0;

  constructor(
    private router: Router,
    private analyticsService: AnalyticsService
  ) {
  }

  ngOnInit(): void {
    this.analyticsService.track(PathUrlEnum.PROPRIETARIO_ERRO);
  }

  navigateToHome() {
    this.analyticsService.trackEvent(PathUrlEnum.PROPRIETARIO_ERRO, EventEnum.BTN_IR_PARA_TELA_INICIAL);
    const formListPath = `/${RouteUtils.PAGES.FORM_LIST}`;

    if (this.router.url === formListPath) {
      this.router
        .navigateByUrl('/', {skipLocationChange: true})
        .then(() => this.router.navigateByUrl(RouteUtils.PAGES.FORM_LIST));
    } else {
      this.router.navigateByUrl(RouteUtils.PAGES.FORM_LIST);
    }
  }

  tryAgainAction() {
    this.analyticsService.trackEvent(PathUrlEnum.PROPRIETARIO_ERRO, EventEnum.BTN_TENTAR_NOVAMENTE);
    this.onClickTryAgain.emit(true);
  }
}
